import * as DisplayNewMessageForm from 'owa-mail-addins/lib/adapters/ReadAdapters/DisplayNewMessageFormAdapter';
import strings from 'owa-strings/owa-mail-strings';
export default function sendFeedbackCallback() {
    var recipients = [
        {
            Name: strings.sendFeedbackDialogTitle,
            EmailAddress: 'outlookinclientstorefeedback@service.microsoft.com',
        },
    ];
    DisplayNewMessageForm.displayNewMessageForm(recipients, [], [], strings.sendFeedbackEmailSubject, strings.sendFeedbackEmailContentStart, []);
}
//# sourceMappingURL=createSendFeedbackCallback.js.map